import { BadgeCheck, BookOpen, Building2, CircleDollarSign, FileText, Palette, Plug } from 'lucide-react'
import { useAuth } from '@/auth/AuthContext'
import { AppShell, type AppNavItem } from '@/components/AppShell'
import { useMcpEnabled } from '@/hooks/useConnectedApps'

const MCP_NAV: AppNavItem[] = [
  { to: '/ops/connected-apps', label: 'Connected apps', icon: Plug },
  { to: '/ops/recognized-apps', label: 'Recognized apps', icon: BadgeCheck },
]

/** The staff ops console shell. Same chrome as the dashboard, marked "ops". */
export function OpsLayout() {
  const { user, logout } = useAuth()
  const mcpEnabled = useMcpEnabled()
  const nav: AppNavItem[] = [
    { to: '/ops/envelopes', label: 'Envelopes', icon: FileText },
    { to: '/ops/tenants', label: 'Tenants', icon: Building2 },
    { to: '/ops/pricing', label: 'Pricing', icon: CircleDollarSign },
    ...(mcpEnabled ? MCP_NAV : []),
    { to: '/ops/design', label: 'Design system', icon: Palette },
    { to: '/docs', label: 'API docs', icon: BookOpen },
  ]
  return (
    <AppShell
      homeTo="/ops/envelopes"
      brandSuffix="ops"
      nav={nav}
      {...(user ? { userEmail: user.email } : {})}
      onSignOut={logout}
    />
  )
}
